angular.module('rjmNg.api').factory("Structure", [
  () ->
    class Structure
      constructor: (tableList, columnList) ->
        @tables = _.object(
          _.pluck(tableList, 'id')
          tableList
        )

        @columns = _.object(
          _.pluck(columnList, 'id')
          columnList
        )

        for column in columnList
          table = @tables[column.table_id]
          if table?
            (table.columns ? table.columns = []).push(column)

        @getTable = (id = null) ->
          if id? then @tables[id] else @tables
  ]
)
